import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { FileEntity } from './file.entity';

@Index('client__file__fk__file__id_fk', ['fkFileId'], {})
@Index('client__file__fk_client__id_fk', ['fkClientId'], {})
@Entity('client__file')
export class ClientFileEntity extends BaseEntity {
	@Column('int', { name: '_fk__file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => FileEntity, (file) => file.clientFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
